import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(() => ({
  navigationHelpACModal: {
    display: "flex",
    maxWidth: "640px",
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "stretch",
    "& .modal-title": {
      padding: 0,
    },
    "& .modal-body": {
      padding: "4px 24px 24px",
    },
    "& .modal-header": {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "row",
      paddingBottom: "20px",
      "& #uc-header-title": {
        display: "flex",
        alignItems: "center"
      }
    },
  },
  cards: {
    display: "flex",
    gap: "16px",
    marginTop: "16px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column",
    },
  },
  card: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${colors.lightGrey}`,
    borderRadius: "8px",
    padding: "20px",
    gap: "12px",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    color: colors.grey,
    margin: 0,
  },
  cardDescription: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.inactiveGrey,
    margin: 0,
    flexGrow: 1,
  },
  continueBtn: {
    justifyContent: "center",
    width: "100px",
    backgroundColor: `${colors.vividRed} !important`,
    "&:hover": {
      backgroundColor: `${colors.brightRed} !important`,
    },
  },
  iconWrapper: {
    border: "1px solid" + colors.lightGrey,
    borderRadius: "10px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    marginRight: "10px"
  },
  title: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    color: colors.lightBlack,
    marginBottom: 0,
  },
  desc: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    color: colors.inactiveGrey,
  },
  textWrapper: {
    marginRight: "10px"
  },
  divider: {
    margin: "0px",
    color: colors.lightGrey,
    opacity: 1,
  },
}));

export default styles;
